<template>
  <div style="width:100%;float:left;">
    <div style="width:100%;float:left;" v-if="!loading && data && current && !pdfLoading">
      <CRow class="mb-2">
        <h5 style="width:100%;float:left;text-align:center;font-size:13px;">Click on a box to change the order you're viewing...</h5>
        <CCol sm="12" md="8">
          <div class="groupOption col-sm-6 col-md-3" :class="current.order_group_id === val.order_group_id ? 'current' : ''" @click="groupClicked(val)" v-for="val in data">
            <label style="width:100%;float:left;padding-top:5px;">{{val.as400_log_number}}</label>
            <label style="width:100%;float:left;">{{val.program_name}}</label>
            <label style="width:100%;float:left;">{{val.order_items.length}} Item(s)</label>
          </div>
        </CCol>
        <!-- <CCol sm="12" md="4">
          
        </CCol> -->
      </CRow>
      <CRow v-if="current">
        <div style="width:100%;float:left;" class="pl-3 pr-3" v-if="current.backorders && current.backorders.length > 0">
          <CCard>
            <CCardHeader @click="backorderModal = !backorderModal">
              Backorders
              <div class="card-header-actions">
                <CLink class="card-header-action btn-minimize">
                    <CIcon :name="`cil-chevron-${backorderModal ? 'bottom' : 'top'}`"/>
                </CLink>
              </div>
            </CCardHeader>
            <CCollapse :show="backorderModal" :duration="400">
              <CCardBody>
                <!-- <h5 style="width:100%;float:left;text-align:center;font-size:13px;">Backorders that are tied with this order.</h5> -->
                <CCol sm="12" md="8">
                  <div class="groupOption col-sm-6 col-md-3" style="height:30px;" @click="backorderClicked(v)" v-for="v in current.backorders">
                    <label style="width:100%;float:left;padding-top:5px;">{{v.as400_log_number}}</label>
                  </div>
                </CCol>
              </CCardBody>
            </CCollapse>
          </CCard>
        </div>
        <div style="width:100%;float:left;" v-if="!pdfLoading">
          <CCol style="float:left;" sm="12" md="8">
            <pdf-display :fromSummary="true" :pdf="current" :form="form"></pdf-display>
          </CCol>
          <CCol style="float:left;" sm="12" md="4">
            <CCard class="mb-3" v-if="form && form.customer_info">
              <CCardHeader @click="customerInsightsCollapsed = !customerInsightsCollapsed" style="cursor:pointer;">
                Customer Insights
                <div class="card-header-actions">
                  <CLink class="card-header-action btn-minimize" @click.stop="customerInsightsCollapsed = !customerInsightsCollapsed">
                    <CIcon :name="`cil-chevron-${customerInsightsCollapsed ? 'bottom' : 'top'}`"/>
                  </CLink>
                </div>
              </CCardHeader>
              <CCollapse :show="!customerInsightsCollapsed" :duration="250">
                <CCardBody>
                  <small-loader v-if="customerInsightsLoading" />
                  <div v-else-if="customerInsights">
                    <div class="mb-3 text-center col-12">
                      <medium class="text-muted">Sales shown are estimated from ACE order data and may differ slightly from NetSuite if later adjustments were made.</medium>
                    </div>
                    <div class="row mb-3">
                      <div class="col-6 col-md-3">
                        <small class="insight-kicker">Orders</small>
                        <strong>{{ customerInsights.summary.total_orders }}</strong>
                      </div>
                      <div class="col-6 col-md-3">
                        <small class="insight-kicker">Units</small>
                        <strong>{{ customerInsights.summary.total_units }}</strong>
                      </div>
                      <div class="col-6 col-md-3 mt-2 mt-md-0">
                        <small class="insight-kicker">Sales</small>
                        <strong>{{ formatInsightCurrency(customerInsights.summary.total_sales) }}</strong>
                      </div>
                      <div class="col-6 col-md-3 mt-2 mt-md-0">
                        <small class="insight-kicker">Last Order</small>
                        <strong>{{ formatInsightDate(customerInsights.summary.last_order_date) }}</strong>
                      </div>
                    </div>

                    <div class="d-md-flex align-items-center mb-3">
                      <label class="mb-1 mb-md-0 mr-md-2">View</label>
                      <select v-model="customerInsightView" class="form-control form-control-sm" style="max-width:280px;">
                        <option value="top_styles">Top Styles</option>
                        <option value="top_programs">Top Programs</option>
                        <option value="top_artwork">Top Artwork</option>
                        <option value="top_locations">Top Locations</option>
                        <option value="recent_orders">Recent Orders</option>
                      </select>
                    </div>

                    <div v-if="customerInsightView === 'top_styles' && currentInsightRows.length" class="table-responsive">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th>Style</th>
                            <th>Program</th>
                            <th class="text-right">Units</th>
                            <th class="text-right">% Ordered</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in currentInsightRows" :key="'style-' + index">
                            <td>{{ row.style_name }}</td>
                            <td>{{ row.program_name || '-' }}</td>
                            <td class="text-right">{{ row.total_units }}</td>
                            <td class="text-right">{{ formatInsightPercent(row.total_units, customerInsights.summary.total_units) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else-if="customerInsightView === 'top_programs' && currentInsightRows.length" class="table-responsive">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th>Program</th>
                            <th class="text-right">Units</th>
                            <th class="text-right">Sales</th>
                            <th class="text-right">Orders</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in currentInsightRows" :key="'program-' + index">
                            <td>{{ row.program_name || '-' }}</td>
                            <td class="text-right">{{ row.total_units }}</td>
                            <td class="text-right">{{ formatInsightCurrency(row.total_sales) }}</td>
                            <td class="text-right">{{ row.order_count }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else-if="customerInsightView === 'top_artwork' && currentInsightRows.length" class="table-responsive">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th>Artwork</th>
                            <th>Location</th>
                            <th class="text-right">Uses</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in currentInsightRows" :key="'art-' + index">
                            <td>{{ row.file_name || '-' }}</td>
                            <td>{{ row.location_name || '-' }}</td>
                            <td class="text-right">{{ row.uses }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else-if="customerInsightView === 'top_locations' && currentInsightRows.length" class="table-responsive">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th>Location</th>
                            <th class="text-right">Uses</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in currentInsightRows" :key="'loc-' + index">
                            <td>{{ row.location_name || '-' }}</td>
                            <td class="text-right">{{ row.uses }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else-if="customerInsightView === 'recent_orders' && currentInsightRows.length" class="table-responsive">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th>Order #</th>
                            <th>Date</th>
                            <th class="text-right">Units</th>
                            <th class="text-right">Sales</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in currentInsightRows" :key="'recent-' + index">
                            <td>{{ row.order_id }}</td>
                            <td>{{ formatInsightDate(row.created_at) }}</td>
                            <td class="text-right">{{ row.total_units }}</td>
                            <td class="text-right">{{ formatInsightCurrency(row.total_sales) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else class="text-muted">No customer insight data available for this view.</div>
                  </div>
                  <div v-else class="text-muted">No customer insight data available yet.</div>
                </CCardBody>
              </CCollapse>
            </CCard>

            <CCard class="mb-3" v-if="artRequestQueue.length">
              <CCardHeader @click="artRequestModal = !artRequestModal">
                Art Requests
                <div class="card-header-actions">
                  <CLink class="card-header-action btn-minimize">
                    <CIcon :name="`cil-chevron-${artRequestModal ? 'bottom' : 'top'}`"/>
                  </CLink>
                </div>
              </CCardHeader>
              <CCollapse :show="artRequestModal" :duration="400">
                <CCardBody>
                  <div v-for="item in artRequestQueue" :key="'art_request_' + item.id" class="art-request-row">
                    <div>
                      <div class="art-request-title">{{ item.bundle_name || 'Bundle' }} / {{ item.bundle_placement_name || 'Placement' }}</div>
                      <div class="art-request-meta">{{ item.request_type }} • {{ item.technique_name || '—' }} • {{ formatArtRequestLocation(item) }}</div>
                    </div>
                    <div class="art-request-actions">
                      <div class="art-request-status">{{ item.status }}</div>
                      <CButton size="sm" color="light" @click="openArtRequestAction(item)">Open</CButton>
                    </div>
                  </div>
                  <CButton size="sm" color="light" @click="$router.push('/art_request_queue')">
                    Open Queue
                  </CButton>
                </CCardBody>
              </CCollapse>
            </CCard>
            <order-actions @approve="approveCheck()" @got-order="setOrder" :order_id="order_id" :pdf="current" :form="form" :users="users"></order-actions>
            <chat :order_id="order_id" :order_group_id="current.order_group_id"></chat>
            <timeline :order_id="order_id" :order_group_id="current.order_group_id"></timeline>
            <people-involved :order_id="order_id" :order_group_id="current.order_group_id"></people-involved>
          </CCol>
          <CCol sm="12" style="float:left;" v-if="current.order_items[0].program_info.show_production_notes">
            <spacer />
            <production-notes v-if="$store.state.user.user_type !== 'rep'" :val="current" :editable="configureProductionEdit()" :fromSummary="true"></production-notes>
          </CCol>
        </div>
        <small-loader v-if="pdfLoading"></small-loader>
      </CRow>
    </div>
    <small-loader v-else></small-loader>

    <!-- <other-customer-orders v-if="form && current" :form="form" :current="current"></other-customer-orders> -->

    <CModal
      :show.sync="approveModal"
      title="Approve Order(s)"
      size="lg">
      <div style="width:100%;float:left;" v-if="modalData">
        <h5 style="width:100%;float:left;text-align:center;font-size:13px;">Click the checkbox if you WANT to approve the order(s)</h5>

        <div class="all float-left mb-3">
          PO# For Whole Order (If wanted): 
          <input type="text" style="width:450px;" class="form-control" v-model="form.po_number" />
        </div>
        <table class="table mt-2" style="border:1px solid red;">
          <thead>
            <tr>
              <th style="border-top:1px solid red;">
                <input type="checkbox" class="form-control" v-model="allApprovedValue" @change="changeAll" style="transform: scale(.5);" />
              </th>
              <th style="border-top:1px solid red;">Log#</th>
              <th style="border-top:1px solid red;">Style(s)</th>
              <th style="border-top:1px solid red;">Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(val, index) in modalData">
              <td>
                <input type="checkbox" v-model="val.approve" class="form-control" style="transform: scale(.5);" />
              </td>
              <td>{{val.as400_log_number}}</td>
              <td>
                <div v-for="v in val.items">
                  {{v.style_info.style_name}},
                </div>
              </td>
              <td>
                {{val.quantity}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <CButton @click="modalData = null, approveModal = false" color="danger">Cancel</CButton>
        <CButton color="success" @click="approveOrders()">Approve Order(s)</CButton>
      </template>
    </CModal>

    <art-request-action-modal
      :show.sync="artRequestActionOpen"
      :queue-id="selectedArtRequestQueueId"
      @saved="loadArtRequestQueue"
    />
  </div>
</template>
<script>
import OrderActions from './../components/order_actions'
import Chat from './../components/group_chat'
import Timeline from './../components/group_timeline'
import PdfOrder from './../components/pdf_order'
import PeopleInvolved from './../components/people_involved'
import OtherCustomerOrders from './../components/other_customer_orders'
import ProductionNotes from './../components/production_notes'
import PdfDisplay from './pdf_display'
import ArtRequestActionModal from './art_request_action_modal'
var methods = {}

methods.configureProductionEdit = function () {
  var v = true
  if (this.current.group_number) {
    v = false
  }
  return v
}

methods.approveCheck = function () {
  console.log(this.data)
  console.log(this.current)
  var that = this
  var arr = []
  this.data.forEach(function (val) {
    if (val.as400_log_number === that.current.as400_log_number) {
      var obj = {
        as400_log_number: val.as400_log_number,
        order_group_id: val.order_group_id,
        order_id: val.order_id,
        approve: false,
        items: val.order_items,
        quantity: that.configureQuantity(val.order_items)
      }
      arr.push(obj)
    } else if (val.as400_status === 'Waiting On Customer') {
      var obj = {
        as400_log_number: val.as400_log_number,
        order_group_id: val.order_group_id,
        order_id: val.order_id,
        approve: false,
        items: val.order_items,
        quantity: that.configureQuantity(val.order_items)
      }
      arr.push(obj)
    }
  })
  this.modalData = arr
  this.approveModal = true
}

methods.approveOrders = function () {
  this.loading = true
  const postData = {
    orders: this.modalData,
    form: this.form
  }
  axios.post(this.$apiAdress + '/api/orders/approveOrderGroups?token=' + localStorage.getItem('api_token'), postData).then(response => {
    window.location.reload()
  }).catch(e => {
    this.loading = false
  })
}

methods.changeAll = function () {
  var that = this
  this.modalData.forEach(function (val){
    if (that.allApprovedValue) {
      val.approve = true
    } else {
      val.approve = false
    }
  })
}

methods.configureQuantity = function (items) {
  var total = 0
  items.forEach(function (item) {
    item.order_item_colors.forEach(function (color) {
      color.sizes.forEach(function (size) {
        if (size.quantity) {
          total += parseInt(size.quantity) || 0
        }
      })
    })
  })
  return total
}

methods.groupClicked = function (val) {
  // this.pdfLoading = true
  // var that = this
  // setTimeout(function () {
  //   that.current = val
  //   that.pdfLoading = false
  // }, 500)
  // this.current = val
  console.log(val.order_group_id)
  console.log(this.order_group_id)
  if (parseInt(val.order_group_id) !== parseInt(this.order_group_id)) {
    this.pdfLoading = true
    this.$router.push('/order/' + this.order_id + '/' + val.order_group_id)
  }
}

methods.backorderClicked = function (val) {
  this.pdfLoading = true
  this.$router.push('/order/' + val.order_id + '/' + val.order_group_id)
}

methods.getOrder = function () {
  this.currentLoading = true
  const postData = {
    order_id: this.order_id
  }
  var that = this
  axios.post(this.$apiAdress + '/api/orders/getOrderDisplay?token='+localStorage.getItem('api_token'), postData)
  .then(response => {
    console.log('pdf orderrrrr')
    console.log(response.data)
    var arr = []
    // this.collapsed = arr
    this.form = response.data.order
    this.users = response.data.users
    console.log(this.form.user);
    // this.$store.commit('setOrder', response.data)
    this.getPdfData(response.data.order).then(res => {
      console.log('pdf')
      console.log(res)
      that.data = res
      // var that = this
      if (!that.order_group_id) {
        that.current = that.data[0]
        that.currentIndex = 0
        that.loading = false
        that.currentLoading = false
      } else {
        var i = 0
        var cur = ''
        var curI = ''
        res.forEach(function (v) {
          console.log(v)
          console.log(that.order_group_id)
          if (parseInt(v.order_group_id) === parseInt(that.order_group_id)) {
            cur = v
            curI = i
          }
          i++
        })
        if (cur !== '') {
          that.current = cur
          that.currentIndex = curI
          that.currentLoading = false
          that.loading = false
        } else {
          that.$router.push('/')
        }
      }
      that.$store.commit('setOrder', that.current)
      that.loadArtRequestQueue()
      that.getCustomerInsights()
    })
    
  }).catch(e => {
    console.log(e)
    // if (e.response.status === 422) {
      // this.$router.push('/login')
    // }
  })
}

methods.loadArtRequestQueue = function () {
  var that = this
  axios.get(this.$apiAdress + '/api/art_request_queues?token=' + localStorage.getItem('api_token'), {
    params: {
      order_id: this.order_id
    }
  }).then(function (response) {
    that.artRequestQueue = response.data || []
  }).catch(function () {
    that.artRequestQueue = []
  })
}

methods.formatArtRequestLocation = function (item) {
  if (!item) return '—'
  return [item.location_code, item.location_name].filter(Boolean).join(' - ') || '—'
}

methods.openArtRequestAction = function (item) {
  this.selectedArtRequestQueueId = item && item.id ? item.id : ''
  this.artRequestActionOpen = true
}

methods.resetCustomerInsights = function () {
  this.customerInsights = null
  this.customerInsightView = 'top_styles'
  this.customerInsightsLoading = false
}

methods.getCustomerInsights = function () {
  if (!this.form || !this.form.customer_info || !this.form.customer_info.customer_number) {
    this.resetCustomerInsights()
    return
  }

  this.customerInsightsLoading = true

  axios.post(this.$apiAdress + '/api/reports/getCustomerOrderInsights?token=' + localStorage.getItem('api_token'), {
    customer: this.form.customer_info
  }).then(response => {
    this.customerInsights = response.data
  }).catch(error => {
    this.customerInsights = null
    this.$store.commit('axios_error', error)
  }).finally(() => {
    this.customerInsightsLoading = false
  })
}

methods.formatInsightCurrency = function (value) {
  const amount = Number(value || 0)
  return '$' + amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

methods.formatInsightPercent = function (value, total) {
  const numerator = Number(value || 0)
  const denominator = Number(total || 0)

  if (!denominator) {
    return '0%'
  }

  return ((numerator / denominator) * 100).toFixed(1) + '%'
}

methods.formatInsightDate = function (value) {
  if (!value) {
    return '-'
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return value
  }

  return date.toLocaleDateString()
}

methods.getPdfData = async function (data) {
  var obj = {}
  var o = {}
  var arr = []
  data.order_groups.forEach(function (val) {
    var obj = {}
    for (var key in data) {
      if (key != 'order_groups') {
        obj[key] = data[key]
      }
    }
    for (var key in val) {
      obj[key] = val[key]
    }
    obj.collapsed = false
    arr.push(obj)
  })
  return arr
}

methods.orderClicked = function (order, index) {
  this.currentLoading = true
  this.current = null
  this.currentIndex = null
  var that = this
  setTimeout(function () {
    that.current = order
    that.currentIndex = index
    that.currentLoading = false
  }, 1000)
}

methods.reorder = function () {
  this.$router.push('/create_order/' + this.order_id)
}

methods.setOrder = function (form) {
  console.log('set order')
  console.log(form)
  this.form = form
}

methods.pdfSent = function () {
  this.$emit('pdf-sent')
}

export default {
    // ===Component name
    name: "NewOrderDisplay",
    // ===Props passed to component
    props: ['order_id', 'order_group_id'],
    // ===Components used by this component
    components: {
      Chat,
      Timeline,
      PeopleInvolved,
      PdfOrder,
      OrderActions,
      PdfDisplay,
      OtherCustomerOrders,
      ProductionNotes,
      ArtRequestActionModal
    },
    // ====component Data properties
    data(){
        return{
          data: null,
          loading: false,
          form: null,
          current: null,
          currentLoading: false,
          currentIndex: null,
          pdfLoading: false,
          modalData: null,
          approveModal: false,
          allApprovedValue: false,
          users: null,
          backorderModal: false,
          artRequestQueue: [],
          artRequestModal: true,
          artRequestActionOpen: false,
          selectedArtRequestQueueId: '',
          customerInsights: null,
          customerInsightsLoading: false,
          customerInsightView: 'top_styles',
          customerInsightsCollapsed: true
        }
    },
    watch: {
      'order_id': function (newVal, oldVal) {
        if (newVal) {
          this.loading = true
          this.artRequestQueue = []
          var that = this
          this.getOrder()
          // setTimeout(function () {
          //   that.loading = false
          // },500)
        }
      },
      'order_group_id': function (newVal, oldVal) {
        console.log(newVal)
        if (newVal) {
          this.pdfLoading = true
          var that = this
          setTimeout(function () {
            if (that.data) {
              var i = 0
              that.data.forEach(function (v) {
                if (parseInt(v.order_group_id) === parseInt(newVal)) {
                  that.current = v
                  that.currentIndex = i
                }
                i++
              })
            }
            that.pdfLoading = false
          }, 500)
        }
      }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      console.log('new order')
      console.log(this.order_id)
      console.log(this.order_group_id)
      this.getOrder()
    },
    // ===Computed properties for the component
    computed: {
      currentInsightRows () {
        if (!this.customerInsights) {
          return []
        }

        const map = {
          top_styles: this.customerInsights.top_styles || [],
          top_programs: this.customerInsights.top_programs || [],
          top_artwork: this.customerInsights.top_artwork || [],
          top_locations: this.customerInsights.top_locations || [],
          recent_orders: this.customerInsights.recent_orders || []
        }

        return map[this.customerInsightView] || []
      }
    },
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .groupOption {
    width:200px;height:100px;margin:5px;float:left;
    border-radius: 5px;
    border: 1px solid #000;
    cursor: pointer !important;
    background-color: #b8b8b8;
    box-shadow: 1px 1px 2px 2px grey;

    label {
      cursor: pointer !important;
    }

    &:hover {
      box-shadow: 2px 2px 4px 4px #fff !important;
    }

    &.current {
      box-shadow: 2px 2px 4px 4px grey;
      background-color: #2eb85c;
      border-color: #2eb85c;
      color:white;
    }
  }

  .art-request-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid #e5edf5;
  }

  .art-request-row:last-child {
    border-bottom: 0;
    margin-bottom: 10px;
  }

  .art-request-title {
    font-weight: 600;
  }

  .art-request-meta {
    font-size: 12px;
    color: #71859a;
  }

  .art-request-status {
    text-transform: capitalize;
    font-size: 12px;
    font-weight: 700;
    color: #315f8d;
    white-space: nowrap;
  }

  .art-request-actions {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: end;
  }

  .insight-kicker {
    display: block;
    color: #6c757d;
  }
</style>
